module.exports = __webpack_public_path__ + "static/media/whatsapp.71b7c0ff.gif";